import React, { useState, useRef } from 'react';
import AceEditor from 'react-ace';

// Import Ace Editor modes and themes
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/theme-textmate';
import 'ace-builds/src-noconflict/theme-idle_fingers';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/theme-kuroir';
import 'ace-builds/src-noconflict/theme-twilight';
import 'ace-builds/src-noconflict/theme-xcode';
import 'ace-builds/src-noconflict/theme-solarized_dark';
import 'ace-builds/src-noconflict/theme-solarized_light';
import 'ace-builds/src-noconflict/theme-terminal';

// Import Skulpt - using dynamic imports to avoid module loading issues
// import 'skulpt/dist/skulpt.min.js'; 
// import 'skulpt/dist/skulpt-stdlib.js'; 

function Compiler({ defaultTemplate, setdefaultTemplate }) {

  return (
    <div className="row mb-1">
      <h5 className="text-xl text-gray-700 bg-purple-100 ">
        Enter Default Template here
      </h5>
      <AceEditor
        mode="python"
        theme="textmate"
        value={defaultTemplate}
        onChange={setdefaultTemplate}
        placeholder="Write your function code here..."
        fontSize={20}
        showPrintMargin={true}
        showGutter={true}
        highlightActiveLine={true}
        wrapEnabled={true}
        className="border border-ring-blue-200  col-12"
        style={{ width: '100%', borderRadius: '10px', minHeight: '80px', maxHeight: '120px' }}
      />

    </div>
  );
}

export default Compiler;
